export function gerarLinkWhatsApp(mensagem, telefone = "5541991118133") {
    const mensagemCodificada = encodeURIComponent(mensagem);
    return `https://wa.me/${telefone}?text=${mensagemCodificada}`;
}